import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { ReactComponent as InteractiveIcon } from 'assets/icons/interactive.svg';

import { HOTSPOT_SIZE_PX } from './InteractiveHotspot.config';

interface HotspotProps {
  topPx: number;
  leftPx: number;
}

const StyledHotspot = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;
  background: radial-gradient(70% 68% at 50% 50%, #FFC42A 0%, #D75C97 100%);
  animation: pulse 3s ease-in-out infinite;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  @keyframes pulse {
    0% {
      transform: scale(0);
    }

    10% {
      transform: scale(1.2);
    }

    20% {
      transform: scale(0.85);
    }

    30% {
      transform: scale(1);
    }

    100% {
      transform: scale(0);
  }
`;

const StyleRingAnimation = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 3px solid #d75c97;
  border-radius: 50%;
  animation: ring 0.8s ease-in-out infinite both;

  @keyframes ring {
    0% {
      transform: scale(1);
      opacity: 0.5;
    }

    30% {
      opacity: 0.8;
    }

    80% {
      transform: scale(1.3);
      opacity: 0;
    }

    100% {
      opacity: 0;
      transform: scale(2.2);
    }
  }
`;

/**
 * HOTSPOT ANIMATION
 *
 * Renders a ring pulse animation at specified position
 */
export const HotspotAnimation = ({ topPx, leftPx }: HotspotProps) => {
  return (
    <Box
      position='absolute'
      top={`${topPx}px`}
      left={`${leftPx}px`}
      width={`${HOTSPOT_SIZE_PX}px`}
      height={`${HOTSPOT_SIZE_PX}px`}
      zIndex='hotspot'
      pointerEvents='none'
      transformOrigin='50% 50%'
      transform='scale(1)'
    >
      <StyledHotspot>
        <StyleRingAnimation />
        <Box position='absolute' top={0} left={0} p={2}>
          <InteractiveIcon color='black' width='100%' height='100%' />
        </Box>
      </StyledHotspot>
    </Box>
  );
};
